import React from "react";

// Testsiz ağaçta tek şekil uyuşmazlığı tüm SPA'yı düşürmesin diye:
// hata fırlatan alt ağaç bu panele hapsolur, uygulamanın kalanı yaşar.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary yakaladı:", error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 24, textAlign: "center" }}>
          <h5>Beklenmeyen bir hata oluştu</h5>
          <p>Bu bölüm hata verdi; uygulamanın geri kalanı çalışmaya devam ediyor.</p>
          <button
            className="btn btn-primary"
            onClick={() => this.setState({ hasError: false })}
          >
            Tekrar dene
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
